module.exports = __webpack_public_path__ + "front/img/p13.c1378c44.png";